// extracted by mini-css-extract-plugin
export default {"card":"j7-z"};